/**
 * Hand a question to the shell's Help drawer, the way the design's Help page does (hdQKey:
 * open the assistant, then ask). The drawer answers it through POST /help/ask exactly as
 * it answers a typed question, so there is one answering path.
 *
 * The shell exposes no "open Help with this question" hook yet (reported to the lead:
 * Shell needs one), so this opens the drawer with its own ? key and types the question
 * into the drawer's box, then presses its Ask button. Nothing here answers anything.
 */
const DRAWER = '[data-testid="help-drawer"]';

function fill(box: HTMLTextAreaElement, text: string) {
  // React tracks a controlled value through the native setter plus an input event.
  const set = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value')?.set;
  set?.call(box, text);
  box.dispatchEvent(new Event('input', { bubbles: true }));
}

export function askInHelpDrawer(text: string, win: Window = window): Promise<boolean> {
  const doc = win.document;
  if (!doc.querySelector(DRAWER)) {
    // With focus on the page's own box the shell would ignore ?, so it goes to the window.
    (doc.activeElement as HTMLElement | null)?.blur?.();
    win.dispatchEvent(new KeyboardEvent('keydown', { key: '?', bubbles: true }));
  }
  return new Promise((resolve) => {
    let tries = 0;
    const step = () => {
      const box = doc.querySelector<HTMLTextAreaElement>(`${DRAWER} textarea`);
      if (!box) {
        if (++tries > 40) return resolve(false);
        win.setTimeout(step, 25);
        return;
      }
      fill(box, text);
      // one frame for React to take the value, then the drawer's own Ask button
      win.setTimeout(() => {
        const ask = doc.querySelector<HTMLButtonElement>(`${DRAWER} button[aria-label="Ask"]`);
        if (ask && !ask.disabled) {
          ask.click();
          resolve(true);
        } else resolve(false);
      }, 30);
    };
    step();
  });
}
